import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SceneEditorComponent } from "./scene-editor/scene-editor.component";
import { SceneImporterComponent } from "./scene-importer/scene-importer.component";
import { EditorEntryComponent } from "./editor-entry/editor-entry.component";
import { CreateSceneComponent } from "./create-scene/create-scene.component";
import { SceneListComponent } from "./scene-list/scene-list.component";
import { TouchEditorComponent } from "./touch/touch-editor/touch-editor.component";

export const routes: Routes = [
    {
        path: "", component: EditorEntryComponent,
        children: [
            { path: "list", component: SceneListComponent, data: { state: "lazy1" } },
            { path: "list/:id", component: SceneListComponent },
            { path: "scene/:id", component: SceneEditorComponent },
            { path: "new", component: CreateSceneComponent },
            { path: "new/:mime", component: SceneImporterComponent },
            { path: "importer", component: SceneImporterComponent },
            { path: "importer/:mime", component: SceneImporterComponent },
            { path: "touch/scene/:id", component: TouchEditorComponent }
        ],
    },
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SceneEditorRoutingModule {
}
